import VConsole from 'vconsole';
/**
 * 配置编译环境和线上环境之间的切换
 */
const NODE_ENV = process.env.NODE_ENV;
let PROXY_URL = {}; // 接口地址

if (NODE_ENV === 'development' || NODE_ENV === 'test') {
	PROXY_URL = {
		activNo: 'HD201811299812',
		config: '//api8.xubei-test.com',
		user: '//passport-server.xubei-test.com',
		service: '//common-server.xubei-test.com',
		home: '//m.xubei-test.com',
		domaiUrl: 'xubei-test.com',
		userServer: '//user-server.xubei-test.com',
		tracking: '//tracking.xubei-test.com'
	};
	new VConsole();
} else if (NODE_ENV === 'pre') {
	// 准生产
	PROXY_URL = {
		activNo: 'HD201811299812',
		config: '//api8.xubei-prd.com',
		user: '//passport-server.xubei-prd.com',
		service: '//common-server.xubei-prd.com',
		home: '//m.xubei-prd.com',
		domaiUrl: 'xubei-prd.com',
		userServer: '//user-server.xubei-prd.com',
		tracking: '//tracking.xubei-prd.com'
	};
	new VConsole();
} else {
	// 生产环境
	PROXY_URL = {
		activNo: 'HD201811299812',
		config: '//api8.xubei.com',
		user: '//passport-server.xubei.com',
		service: '//common-server.xubei.com',
		home: '//m.xubei.com',
		domaiUrl: 'xubei.com',
		userServer: '//user-server.xubei.com',
		tracking: '//tracking.xubei.com'
	};
}

export { PROXY_URL };



// WEBPACK FOOTER //
// ./src/config/env.js